import { EuiAccordion, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiLink, EuiPanel } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import Flag from 'react-flagkit';
import { TablaDetalleHistoricoAdjuntosExpatriados } from './tablaDetalle';
import './styles.css'


export const AdjuntosExpatriadosHistoricoScreen = (props) =>{

    const { data, handleGetAdjuntosHistoricoPorPais, handleDownloadAdjuntoHistorico, handleDownloadAllAdjuntosHistorico, translate } = props;
    const [selected, setSelected] = useState(undefined);
    const [search, setSearch] = useState('');

    useEffect(()=>{
        if(selected===undefined && data.length>0){
            handleGetAdjuntosHistoricoPorPais(data[0],setSelected)
        }
    },[selected,data,handleGetAdjuntosHistoricoPorPais])

    const onChange = (newSelected) =>{
        handleGetAdjuntosHistoricoPorPais(newSelected,setSelected)
    }

    const getSearch = useMemo(()=>{
        return data && data.filter((f)=> { 
            if(new RegExp(`${search}.*`, "i").test(f["pais"])){return f}
        })
      },[data,search])

    const getItemsPaises = useMemo(() =>{
        const filterArray = getSearch;
        return data && filterArray.map((d)=>{
            return (<EuiFlexItem grow={false}>
                      <EuiLink
                      className={`btn-list-user-permission ${selected && d.codPais===selected.codPais?'active':''}`}
                      onClick={() => {onChange(d)}}
                      >
                      <EuiFlexGroup justifyContent='spaceAround' alignItems='center' gutterSize='s'>
                          <EuiFlexItem grow={false}>{(<Flag country={d.codPais} /> || undefined)}</EuiFlexItem>
                          <EuiFlexItem title={d.pais}>{`${d.pais}`}</EuiFlexItem>
                      </EuiFlexGroup>
                      </EuiLink>
            </EuiFlexItem>)
        })
    },[data,search,selected])

    const getAdjuntos = (adjuntos) =>{
        return (<TablaDetalleHistoricoAdjuntosExpatriados data={adjuntos} downloadAdjuntoUser={handleDownloadAdjuntoHistorico} 
        donwloadAllAdjuntosUser={handleDownloadAllAdjuntosHistorico} translate={translate}/>)
    }

    const getHistorico = useMemo(()=>{
        const historico = (selected && selected.historico) || [];
        return historico.map((h)=> 
            (
                <EuiAccordion
                buttonContent={h.sociedad} 
                element="fieldset" className="euiAccordionForm acordion-adjuntos-historico-expatriado" paddingSize="l">
                <EuiPanel paddingSize='s'><EuiFlexGroup direction='column'>{getAdjuntos(h)}</EuiFlexGroup></EuiPanel>
                </EuiAccordion>
            )
        )
    },[selected,translate])

    return (
        <EuiFlexGroup direction='column' style={{height:'100%'}} gutterSize='none'>
            <EuiFlexItem style={{height:'100%'}}>
                <EuiFlexGroup style={{height:'100%'}} gutterSize='none'>
                    <EuiFlexItem grow={false} style={{overflow:'hidden'}}>
                        <EuiPanel style={{overflow:'hidden',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                        <EuiFlexGroup direction='column' style={{height:'100%'}}>
                            <EuiFlexItem grow={false}>
                                <EuiFieldText placeholder={`${translate('buscar')} ${translate('pais')}...`} value={search} onChange={(e)=>setSearch(e.target.value)}></EuiFieldText>
                            </EuiFlexItem>
                            <EuiFlexItem style={{overflow:'hidden'}}>
                            <EuiFlexGroup direction='column' style={{height:'100%',width:'100%',overflow:'auto'}} gutterSize='m'>
                                {getItemsPaises}
                            </EuiFlexGroup>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        </EuiPanel>
                    </EuiFlexItem>

                    <EuiFlexItem>
                        <EuiPanel style={{height:'100%',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px'}}>
                        {selected ?
                        <>
                        {/* <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap style={{height:'10%'}}>
                            <EuiFlexItem grow={false}>
                            
                            </EuiFlexItem>
                        </EuiFlexGroup> */}
                        <EuiFlexGroup gutterSize='none' style={{height:'100%'}}>
                            <EuiFlexItem style={{height:'100%'}}>
                                <EuiPanel style={{height:'100%',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                                    {getHistorico}
                                </EuiPanel>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        </>
                        :null}
                        </EuiPanel>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}